<template>
	<div class="llogin" @click="closelogin">
		<div class="login" @click.stop="">
			<div class="from padding">
				<p class="title text-333 text-bold text-left margin-bottom margin-top-sm">添加章节</p>
				<div class="flex align-center margin-top-sm">
					<p class="margin-right-sm">章节名称</p>
					<div class="right-r">
						<input type="text" class="input-name padding-left-sm" v-model="title" maxlength="16" placeholder="请输入目录章节名称（仅限16字以内）" />
					</div>
				</div>
				<div class="flex align-center margin-top-sm">
					<p class="margin-right-sm">章节上传</p>
					<el-upload
					  class="upload-demo"
					  action="https://manage.ciiply.com/api/pc/user/upFile"
					  :on-change="handleChange"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess"
					  :before-upload="beforeAvatarUpload"
					  :limit="1"><!-- :file-list="fileList" -->
					  <div class="right-r flex align-center justify-between">
						<p v-if="resources" class="text-theme text-cut pointer padding-left-sm">{{resources}}</p>
					  	<p v-else class="text-theme pointer padding-left-sm">{{type == 0?'点击上传本地视频文件':'点击上传本地文件'}}</p>
					  	<p class="local pointer">本地上传</p>
					  </div>
					</el-upload>
					<!-- <div class="right-r flex align-center justify-between">
						<p class="text-theme pointer padding-left-sm">点击上传本地文件</p>
						<p class="local pointer">本地上传</p>
					</div> -->
				</div>
				<div class="sub_add text-white pointer" @click="btnsub">确认添加</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				fileList:null,//文件
				title:'',//名称
				type:'',//类型
				id:0,
				resources:'',
				isedut:false,
				editid:0
			};
		},
		created(){
			Bus.$on('release',data=>{
				console.log('*-*-*-*-*-*-*-*-*-*-*-*',data);
				// id:res.data,
				// type:this.aindex
				this.id = data.id
				this.type = data.type
			})
			Bus.$on('editrelease',item=>{
				console.log(item);
				this.resources = item.resources
				this.title = item.chapter_title
				this.editid = item.id
				this.isedut = true
			})
		},
		destroyed() {
			Bus.$off('release','editrelease')
		},
		methods: {
			//关闭添加章节弹窗
			closelogin(){
				this.$emit('closelogin')
				Bus.$off('release','editrelease')
			},
			//上传本地文件
			handleChange(file, fileList) {
				// console.log(file,fileList);
				// this.fileList = file
			},
			/**
			 * 上传图片
			 * */
			beforeAvatarUpload(file) {
				
			},
			/**
			 * 上传
			 * */
			handleAvatarSuccess(res, file) {
				
				this.resources = res.data.url;
			},
			btnsub(){
				
				if(this.isedut){
					this.editcour()
				}else{
					this.add()
				}
			},
			/**
			 * 添加章节
			 * */
			add(){
				let data={
					course_id:this.id,
					chapter_title:this.title,
					resources:this.resources,
					is_free:1
				}
				// return console.log(data);
				this.ajax('post', '/api/courseapply/addChatper',data, res => {
					console.log(res);
					if(res.status == 200){
						setTimeout(()=>{
							Bus.$emit('addChatper')
						},500)
						this.closelogin()
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 编辑章节
			 * */
			editcour(){
				let data={
					course_id:this.id,
					chapter_title:this.title,
					resources:this.resources,
					id:this.editid,
				}
				
				this.ajax('post', '/api/pc/courseapply/editChatper',data, res => {
					console.log(res);
					if(res.status == 200){
						setTimeout(()=>{
							Bus.$emit('addChatper')
						},500)
						this.closelogin()
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped>
	.llogin {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.6600);
		z-index: 999999;
	}

	.login {
		width: 711px;
		height: 528px;
		background: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
	}

	.title {
		font-size: 28px
	}

	.right-r{
		width: 513px;
		height: 54px;
		background: rgba(255,255,255,0.3000);
		border: 1px solid #E6E6E6;
		border-radius: 8px;
		
	}
	.input-name{
		width:480px;
		height: 50px;
		border: 0;
		outline: 0;
	}
	.local{
		width: 104px;
		height: 54px;
		line-height: 54px;
		background: rgba(9,130,123,0.1000);
		border-radius: 0px 8px 8px 0px;
		color: #09827B;
	}
	.sub_add{
		width: 383px;
		height: 60px;
		line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2000);
		border-radius: 30px;
		position: absolute;
		bottom: 105px;
		left: 50%;
		transform: translateX(-50%);
	}
</style>



// WEBPACK FOOTER //
// src/components/my/curriculum/chapter.vue